<template>
    <v-dialog max-width="80%" v-model="dialog">
        <template v-slot:activator={on}>
            <v-btn text icon v-on=on>
                <v-icon small>mdi-delete</v-icon>
            </v-btn>
        </template>
        <v-card :loading="loading">
            <v-card-title>Are you sure do you want delete this Supplier ?</v-card-title>
            <v-card-actions>
                <v-btn @click="dialog=false">Cancel</v-btn>
                <v-spacer />
                <v-btn @click="save" color="primary">Delete</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    data: () => ({
        dialog:null,
        rules: {
            required: value => !!value || "This field is mandatory.",
        },
        loading:false,
        errors:[]
    }),
    props:{
        supplier:{
            type:Object,
            required:true
        }
    },
    computed:{
        model(){
            return this.supplier
        }
    },
    methods:{
        ...mapActions("supplier", ["delete"]),
        save(){
            this.errors=[]
            this.loading=true
            this.delete(this.model)
            .then(() => {
                this.$emit("saved")
                this.dialog=false
            })
            .catch(({data}) => {
                for (const error of Object.entries(data.errors)) {
                    this.errors.push(error[1][0])
                }
            })
            .finally(() => {
                this.loading=false
            })
        }
    }
}
</script>

<style>

</style>